/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  AdCompleteRequest,
  AdCompleteResponse,
  AdStartRequest,
  AdStartResponse,
  AdminConfigReloadResponse,
  CloseSeason200,
  CloseSeasonParams,
  MissionClaimRequest,
  MissionClaimResponse,
  MissionListResponse,
  PrizePoolResponse,
  PunchBatchRequest,
  PunchBatchResponse,
  PunchSingleRequest,
  RankingMeResponse,
  RankingTopResponse,
  RecentTickerParams,
  StateResponse,
  TickerResponse,
  Top50Params,
} from '.././model';

/**
 * 본문을 단일 이벤트 배치로 변환하여 punch/batch와 동일한 processBatch 로직으로 처리합니다.
 * @summary 펀치 단건 처리
 */
export type punchSingleResponse200 = {
  data: PunchBatchResponse;
  status: 200;
};

export type punchSingleResponseSuccess = punchSingleResponse200 & {
  headers: Headers;
};
export type punchSingleResponse = punchSingleResponseSuccess;

export const getPunchSingleUrl = () => {
  return `/punch/play`;
};

export const punchSingle = async (
  punchSingleRequest: PunchSingleRequest,
  options?: RequestInit,
): Promise<punchSingleResponse> => {
  const res = await fetch(getPunchSingleUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(punchSingleRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: punchSingleResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as punchSingleResponse;
};

/**
 * @summary 미션 클레임 처리
 */
export type claimMissionResponse200 = {
  data: MissionClaimResponse;
  status: 200;
};

export type claimMissionResponseSuccess = claimMissionResponse200 & {
  headers: Headers;
};
export type claimMissionResponse = claimMissionResponseSuccess;

export const getClaimMissionUrl = () => {
  return `/punch/missions/claim`;
};

export const claimMission = async (
  missionClaimRequest: MissionClaimRequest,
  options?: RequestInit,
): Promise<claimMissionResponse> => {
  const res = await fetch(getClaimMissionUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(missionClaimRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: claimMissionResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as claimMissionResponse;
};

/**
 * @summary 연속 펀치 배치 처리
 */
export type punchBatchResponse200 = {
  data: PunchBatchResponse;
  status: 200;
};

export type punchBatchResponseSuccess = punchBatchResponse200 & {
  headers: Headers;
};
export type punchBatchResponse = punchBatchResponseSuccess;

export const getPunchBatchUrl = () => {
  return `/punch/batch`;
};

export const punchBatch = async (
  punchBatchRequest: PunchBatchRequest,
  options?: RequestInit,
): Promise<punchBatchResponse> => {
  const res = await fetch(getPunchBatchUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(punchBatchRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: punchBatchResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as punchBatchResponse;
};

/**
 * @summary 광고 시작 처리(검증 토큰 발급)
 */
export type startAdResponse200 = {
  data: AdStartResponse;
  status: 200;
};

export type startAdResponseSuccess = startAdResponse200 & {
  headers: Headers;
};
export type startAdResponse = startAdResponseSuccess;

export const getStartAdUrl = () => {
  return `/punch/ads/start`;
};

export const startAd = async (adStartRequest: AdStartRequest, options?: RequestInit): Promise<startAdResponse> => {
  const res = await fetch(getStartAdUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: startAdResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as startAdResponse;
};

/**
 * @summary 광고 완료 처리
 */
export type completeAdResponse200 = {
  data: AdCompleteResponse;
  status: 200;
};

export type completeAdResponseSuccess = completeAdResponse200 & {
  headers: Headers;
};
export type completeAdResponse = completeAdResponseSuccess;

export const getCompleteAdUrl = () => {
  return `/punch/ads/complete`;
};

export const completeAd = async (
  adCompleteRequest: AdCompleteRequest,
  options?: RequestInit,
): Promise<completeAdResponse> => {
  const res = await fetch(getCompleteAdUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adCompleteRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: completeAdResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as completeAdResponse;
};

/**
 * 해당 시즌 TOP50 랭킹을 고정 스냅샷으로 저장하고 상금통 80%를 정책 비율로 지급합니다. seasonNo 미입력 시 직전 시즌을 종료합니다.
 * @summary 시즌 종료 및 TOP50 상금 분배
 */
export type closeSeasonResponse200 = {
  data: CloseSeason200;
  status: 200;
};

export type closeSeasonResponseSuccess = closeSeasonResponse200 & {
  headers: Headers;
};
export type closeSeasonResponse = closeSeasonResponseSuccess;

export const getCloseSeasonUrl = (params?: CloseSeasonParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/punch/admin/season/close?${stringifiedParams}` : `/punch/admin/season/close`;
};

export const closeSeason = async (params?: CloseSeasonParams, options?: RequestInit): Promise<closeSeasonResponse> => {
  const res = await fetch(getCloseSeasonUrl(params), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: closeSeasonResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as closeSeasonResponse;
};

/**
 * game_global_config / game_reward_tier 를 다시 읽어 메모리 캐시에 반영합니다. MASTER 또는 YAONG_ADMIN 권한 필요.
 * @summary 냥냥펀치 DB 설정 캐시 수동 리로드
 */
export type reloadPunchRuntimeConfigResponse200 = {
  data: AdminConfigReloadResponse;
  status: 200;
};

export type reloadPunchRuntimeConfigResponseSuccess = reloadPunchRuntimeConfigResponse200 & {
  headers: Headers;
};
export type reloadPunchRuntimeConfigResponse = reloadPunchRuntimeConfigResponseSuccess;

export const getReloadPunchRuntimeConfigUrl = () => {
  return `/punch/admin/config/reload`;
};

export const reloadPunchRuntimeConfig = async (options?: RequestInit): Promise<reloadPunchRuntimeConfigResponse> => {
  const res = await fetch(getReloadPunchRuntimeConfigUrl(), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: reloadPunchRuntimeConfigResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as reloadPunchRuntimeConfigResponse;
};

/**
 * 정책 기준: 100P/150P 당첨만 노출, 시즌별 최대 6개 FIFO
 * @summary 실시간 당첨 티커 조회
 */
export type recentTickerResponse200 = {
  data: TickerResponse;
  status: 200;
};

export type recentTickerResponseSuccess = recentTickerResponse200 & {
  headers: Headers;
};
export type recentTickerResponse = recentTickerResponseSuccess;

export const getRecentTickerUrl = (params?: RecentTickerParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/punch/ticker/recent?${stringifiedParams}` : `/punch/ticker/recent`;
};

export const recentTicker = async (
  params?: RecentTickerParams,
  options?: RequestInit,
): Promise<recentTickerResponse> => {
  const res = await fetch(getRecentTickerUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: recentTickerResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as recentTickerResponse;
};

/**
 * @summary 냥냥펀치 상태 조회
 */
export type getStateResponse200 = {
  data: StateResponse;
  status: 200;
};

export type getStateResponseSuccess = getStateResponse200 & {
  headers: Headers;
};
export type getStateResponse = getStateResponseSuccess;

export const getGetStateUrl = () => {
  return `/punch/state`;
};

export const getState = async (options?: RequestInit): Promise<getStateResponse> => {
  const res = await fetch(getGetStateUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getStateResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getStateResponse;
};

/**
 * @summary 시즌 TOP50 랭킹 조회
 */
export type top50Response200 = {
  data: RankingTopResponse;
  status: 200;
};

export type top50ResponseSuccess = top50Response200 & {
  headers: Headers;
};
export type top50Response = top50ResponseSuccess;

export const getTop50Url = (params?: Top50Params) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/punch/ranking/top50?${stringifiedParams}` : `/punch/ranking/top50`;
};

export const top50 = async (params?: Top50Params, options?: RequestInit): Promise<top50Response> => {
  const res = await fetch(getTop50Url(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: top50Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as top50Response;
};

/**
 * @summary 내 랭킹 조회
 */
export type myRankResponse200 = {
  data: RankingMeResponse;
  status: 200;
};

export type myRankResponseSuccess = myRankResponse200 & {
  headers: Headers;
};
export type myRankResponse = myRankResponseSuccess;

export const getMyRankUrl = () => {
  return `/punch/ranking/me`;
};

export const myRank = async (options?: RequestInit): Promise<myRankResponse> => {
  const res = await fetch(getMyRankUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: myRankResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as myRankResponse;
};

/**
 * @summary 현재 시즌 상금통 조회
 */
export type prizePoolCurrentResponse200 = {
  data: PrizePoolResponse;
  status: 200;
};

export type prizePoolCurrentResponseSuccess = prizePoolCurrentResponse200 & {
  headers: Headers;
};
export type prizePoolCurrentResponse = prizePoolCurrentResponseSuccess;

export const getPrizePoolCurrentUrl = () => {
  return `/punch/prize-pool/current`;
};

export const prizePoolCurrent = async (options?: RequestInit): Promise<prizePoolCurrentResponse> => {
  const res = await fetch(getPrizePoolCurrentUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: prizePoolCurrentResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as prizePoolCurrentResponse;
};

/**
 * @summary 미션 목록/진행 상태 조회
 */
export type missionsResponse200 = {
  data: MissionListResponse;
  status: 200;
};

export type missionsResponseSuccess = missionsResponse200 & {
  headers: Headers;
};
export type missionsResponse = missionsResponseSuccess;

export const getMissionsUrl = () => {
  return `/punch/missions`;
};

export const missions = async (options?: RequestInit): Promise<missionsResponse> => {
  const res = await fetch(getMissionsUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: missionsResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as missionsResponse;
};
